module.exports = __webpack_public_path__ + "img/spresenthologo.7d47e708.png";